import React, { useState, useEffect } from 'react';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import SharedIntlProviderHOC from '../hocs/sharedIntlProviderHOC';
import { LocaleSelector } from '../internationalization/locale-selector';
import Cookie from 'react-cookie';
import get from "lodash/get";
import LocaleAbbreviation from "./LocaleAbbreviation";
import PrivacyOptionsIcon from "./PrivacyOptionsIcon";

const Footer = injectIntl(({ intl, locale, envLocaleData }) => { //this locale and envLocaleData is from the server-side rendering
  const preferredLocale = Cookie.load('preferred_locale'); //use cookie for client-side
  const [displayCountries, setDisplayCountries] = useState(true);
  const currentLocale = locale || preferredLocale || Cookie.load('initial_locale');
  const localeData = envLocaleData || SharedIntlProviderHOC.getEnvLocaleData() || {}; // use sharedintlproviderhoc for client side
  const currentLocaleData = localeData[currentLocale];
  const altText = defineMessages({
    footer: {
      id: 'shared_component.footer.footer_logo',
      defaultMessage: 'Peerspace footer logo'
    },
    download: {
      id: 'shared_component.footer.download_logo',
      defaultMessage: 'download logo'
    }
  });
  const urlPrefix = SharedIntlProviderHOC.getUrlPrefix();
  const urlPrefixLink = urlPrefix ? `/${urlPrefix}` : '';
  const zenDeskLocale = SharedIntlProviderHOC.getZendeskLocale();
  const lang = intl.locale.split('-')[0];

  useEffect(() => {
    setDisplayCountries(!preferredLocale);
  }, [preferredLocale]);

  return (
    <footer>
      <div role="navigation" className="container-fluid">
        <div className="row footer-content">
          <div className="col-xs-12 col-md-3 col-lg-3 footer-peerspace-connect">
            <img
              className="footer-logo"
              src="/web-templates/assets/images/ps_logo_stack_white.svg?v=rb"
              alt={intl.formatMessage(altText.footer)}
            />
            <div>
              <a href="/download">
                <img
                  src={`https://assets.peerspace.com/ios-footer-download-${lang}.svg?v=rb`}
                  alt={intl.formatMessage(altText.download)}
                />
              </a>
            </div>
            <div className="row hidden-xs margin-lg-top">
              <div className="col-xs-12">
                <p className="copyright">
                  &#169; Peerspace&nbsp;-&nbsp;
                  <a href={`${urlPrefixLink}/legal/terms`}>
                    <FormattedMessage id="shared_component.footer.terms" defaultMessage="Terms"/>
                  </a>&nbsp;-&nbsp;
                  <a href={`${urlPrefixLink}/legal/privacy`}>
                    <FormattedMessage id="shared_component.footer.privacy" defaultMessage="Privacy" />
                  </a>
                </p>
              </div>
            </div>
          </div>
          <br className="visible-xs"></br >
          <div className="col-xs-12 col-md-8 col-lg-8">
            <div className="row web-links">
              <div className="col-xs-12 col-sm-4 no-gutter">
                <div className="col-xs-6">
                  <p className="title">
                    <FormattedMessage id="shared_component.footer.company" defaultMessage="Company" />
                  </p>
                  <p>
                    <a id="footer_link_about" href="https://book.peerspace.com/about">
                      <FormattedMessage id="shared_component.footer.about" defaultMessage="About" />
                    </a>
                  </p>
                  <p><a id="footer_link_press" href="//try.peerspace.com/press/"><FormattedMessage id="shared_component.footer.press" defaultMessage="Press" /></a></p>
                  <p><a id="footer_link_careers" href="https://jobs.lever.co/peerspace"><FormattedMessage id="shared_component.footer.careers" defaultMessage="Careers" /></a></p>
                  <p><a id="footer_link_blog" href="/blog"><FormattedMessage id="shared_component.footer.blog" defaultMessage="Blog" /></a></p>
                </div>
                <div className="col-xs-6">
                  <p className="title"><FormattedMessage id="shared_component.footer.social" defaultMessage="Social" /></p>
                  <p><a id="footer_link_facebook" href="https://www.facebook.com/peerspace/">Facebook</a></p>
                  <p><a id="footer_link_instagram" href="https://www.instagram.com/peerspace/">Instagram</a></p>
                  <p><a id="footer_link_twitter" href="https://x.com/Peerspace">Twitter</a></p>
                  <p><a id="footer_link_linkedin" href="https://www.linkedin.com/company/peerspace">LinkedIn</a></p>
                  <p><a id="footer_link_pinterest" href="http://www.pinterest.com/peerspace/">Pinterest</a></p>
                </div>
              </div>
              <div className="col-xs-12 col-sm-4 no-gutter">
                <div className="col-xs-6">
                  <p className="title"><FormattedMessage id="shared_component.footer.explore" defaultMessage="Explore" /></p>
                  <p><a href={`${urlPrefixLink}/plan/activities`}><FormattedMessage id="shared_component.footer.activities" defaultMessage="Activities" /></a></p>
                  <p><a href={`${urlPrefixLink}/venues/locations`}><FormattedMessage id="shared_component.footer.locations" defaultMessage="Locations" /></a></p>
                  <p><a id="footer_link_blog" href="/resources"><FormattedMessage id="shared_component.footer.resources" defaultMessage="Resources" /></a></p>
                  <p><a href="https://madein.peerspace.com/ambassadors"><FormattedMessage id="shared_component.footer.ambassadors" defaultMessage="Ambassador Program" /></a></p>
                </div>
                <div className="col-xs-6">
                  <p className="title"><FormattedMessage id="shared_component.footer.host" defaultMessage="Host" /></p>
                  <p><a id="footer_link_host" href={`${urlPrefixLink}/host`}><FormattedMessage id="shared_component.footer.list_your_space" defaultMessage="List your space" /></a></p>
                  <p><a id="footer_link_forum" href="https://community.peerspace.com"><FormattedMessage id="shared_component.footer.community" defaultMessage="Community" /></a></p>
                </div>
              </div>
              <div className='col-xs-6 col-sm-4 no-gutter'>
                {displayCountries && (<div className="col-xs-6">
                  <p className="title">
                    <FormattedMessage id="shared_component.footer.countries" defaultMessage="Countries" />
                  </p>
                  {
                    Object.keys(localeData || {}).map(locale => (
                      <p key={locale}>
                        <a href={`/${localeData[locale].url_prefix}`}>
                          {localeData[locale].country}
                        </a>
                      </p>
                    ))
                  }
                </div>)}
                <div className="col-xs-6">
                  <p className="title"><FormattedMessage id="shared_component.footer.support" defaultMessage="Support" /></p>
                  <p><a id="footer_link_support" href={`https://support.peerspace.com/hc/${zenDeskLocale}`}><FormattedMessage id="shared_component.footer.help_center" defaultMessage="Help Center" /></a></p>
                  <p><a id="footer_link_covid" href="https://book.peerspace.com/covid-19/overview"><FormattedMessage id="shared_component.footer.covid_measures" defaultMessage="COVID-19 Measures" /></a></p>
                  <p><a id="footer_link_trust" href="https://book.peerspace.com/trust-and-safety"><FormattedMessage id="shared_component.footer.trust_safety" defaultMessage="Trust and Safety" /></a></p>
                  <p>
                    <a className="text-gray-500" id="footer_link_disclosure" href={`${urlPrefix ? `/${urlPrefix}` : ''}/legal/privacy#california-privacy`}>
                      <FormattedMessage
                        id="shared_component.footer.california_privacy_link"
                        defaultMessage="California Privacy"
                      />
                    </a>
                  </p>
                  <p><a id="footer_link_disclosure" href="mailto:vulnerability@peerspace.com"><FormattedMessage id="shared_component.footer.report_vulnerability" defaultMessage="Report Vulnerability" /></a></p>
                </div>
              </div>
            </div>
          </div>
          <div className="container-fluid">
            <div className="row visible-xs margin-xl-bottom">
              <div className="col-xs-12">
                <p className="copyright">
                  &#169; Peerspace&nbsp;-&nbsp;
                  <a href={`${urlPrefixLink}/legal/terms`}>
                    <FormattedMessage id="shared_component.footer.terms" defaultMessage="Terms"/>
                  </a>&nbsp;-&nbsp;
                  <a href={`${urlPrefixLink}/legal/privacy`}>
                    <FormattedMessage id="shared_component.footer.privacy" defaultMessage="Privacy"/>
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-gray-900 padding-xl-left padding-xl-right flex middle">
        <div className="margin-xl-top margin-xl-bottom margin-xl-right margin-xl-left flex middle">
          <LocaleSelector source="footer" activeLocales={envLocaleData}>
            <div className="border-0 text-gray-500 underline">
              {get(currentLocaleData, 'language', 'en-US')} ({LocaleAbbreviation(get(currentLocaleData, 'locale', 'en-US'))})
            </div>
          </LocaleSelector>
          <div className="margin-sm-right margin-sm-left text-gray-500 flex">•</div>
          <div>
            <button
                className="btn-link text-left text-gray-500 no-padding"
                id="footer_link_cookies"
                onClick={() => {
                  if (typeof window !== 'undefined') {
                    window.consentManager.openConsentManager()
                  }
                }}
            >
              <FormattedMessage id="shared_component.footer.your_privacy_choices" defaultMessage="Your privacy choices" />
            </button>
          </div>
          <div className="margin-sm-left flex">
            <PrivacyOptionsIcon />
          </div>
        </div>
      </div>
    </footer>
  );
});

class IntlFooter extends React.Component {
  constructor (props) {
    super(props);
  }

  render () {
    return (
      <SharedIntlProviderHOC locale={this.props.locale} envLocaleData={this.props.envLocaleData}>
        <Footer {...this.props}/>
      </SharedIntlProviderHOC>
    );
  }
}

exports.Footer = IntlFooter;
